(ns client-portal.client.reports.components.category-score-gauge-with-line-chart
  (:require [cljs-time.format :as t.f]
            [shared.core.components.components :as c]
            [shared.core.components.recharts-components :as recharts.c]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(defn- format-date [{:keys [date date-format]}]
  (if (string? date)
    (let [hourly? (re-find #":" date)
          parser (t.f/formatter (if hourly? "yyyy-MM-dd HH:mm" "yyyy-MM-dd"))]
      (->> (t.f/parse parser date)
           (t.f/unparse (t.f/formatter (or date-format (if hourly? "MMM d, h a" "MMM d"))))))
    date))

(defn category-score-gauge-with-line-chart [_]
  (let [selected-location-id- (re/subscribe [:locations/current-selected-location-id-])
        parse-rows (fn [data]
                     (->> (util/when-not-loading data)
                          (keep (fn [{:keys [date score]}]
                                  (when-some [s (util/parse-float score)]
                                    {:date date :score (min s 100)})))
                          (sort-by :date)))]
    (fn [{:keys [location-data concept-data category label date-format title icon-type color gauge-config]}]
      (let [title (or title (str (some-> category (util/->capitalize-words)) " Score"))
            icon-type (or icon-type :insights)
            color (or color (util/str->hex category))]
        (if (util/loading? (:data location-data))
          [c/loader-rectangle {:style {:flex 1
                                       :height 340}}]
          (let [rows (parse-rows (:data location-data))
                scores (mapv :score rows)
                avg (some-> (util/mean scores) (js/Math.round))
                concept-avg (when @selected-location-id-
                              (some-> (util/mean (mapv :score (parse-rows (:data concept-data))))
                                      (js/Math.round)))
                difference (if (not-empty scores)
                             (- (last scores) (first scores))
                             0)
                area-data (mapv (fn [{:keys [date score]}]
                                  {:x (format-date {:date date :date-format date-format}) :y score})
                                rows)
                need-y-max? (and concept-avg (some #(> concept-avg (:y %)) area-data))
                subtitle (when (not-empty scores)
                           (str (js/Math.abs (js/Math.round difference)) " over selected dates"))
                subtitle-icon (if (>= difference 0) :expand-less :expand-more)
                subtitle-icon-color (if (>= difference 0)
                                      (style/color :green :shade-8)
                                      (style/color :red :shade-6))]
            (if (empty? rows)
              [alc/card {:title title
                         :material-icon-type icon-type
                         :color color
                         :style {:flex 1
                                 :padding "16px 0px 26px"}
                         :header-style {:padding "0 16px"}}
               [:div {:style {:display :flex
                              :align-items :center
                              :justify-content :center
                              :height 300
                              :color (style/alc-color "Text/secondary")}}
                "No data"]]
              [alc/card {:title title
                         :material-icon-type icon-type
                         :color color
                         :style {:flex 1
                                 :padding "16px 0px 26px"}
                         :header-style {:padding "0 16px"}}
               [:div {:style {:display :flex
                              :flex-direction :column
                              :align-items :center
                              :gap 12
                              :padding "0 12px"}}
                [:div {:style {:position :relative}}
                 [recharts.c/gauge-chart (merge {:label label
                                                 :value avg
                                                 :stops [25 50 25]
                                                 :colors ["#FF8080" "#FEAC2A" "#4AC53F"]
                                                 :average concept-avg}
                                                gauge-config)]
                 (when subtitle
                   [:div {:style {:display :flex
                                  :align-items :center
                                  :justify-content :center
                                  :position :absolute
                                  :bottom 10
                                  :left "50%"
                                  :transform "translateX(-50%)"
                                  :width "100%"}}
                    [alc/material-icon {:icon-type subtitle-icon
                                        :style {:color subtitle-icon-color
                                                :font-size 16}}]
                    [:span {:style {:font-family style/roboto-font-family
                                    :font-size 11
                                    :line-height :normal
                                    :font-weight style/font-medium-weight
                                    :color (style/alc-color "Text/secondary")}}
                     subtitle]])]
                [recharts.c/area-chart (cond-> {:data area-data
                                                :x-key :x
                                                :y-key :y
                                                :average (when concept-avg
                                                           {:value concept-avg :label (str "All Locations Avg. " concept-avg)})
                                                :id (or category title)
                                                :color color
                                                :smooth? false
                                                :tooltip-label-fn (fn [] title)}
                                         need-y-max?
                                         (assoc :y-domain [0 (min (+ concept-avg 5) 100)]))]]])))))))